// project-imports
import master from "./master";
import dashboard from "./dashboard";
import users from "./user";
import cloudview from "./cloudview";

// types
import { NavItemType } from "types/menu";
import applications from "./applications";
import transaction from "./transaction";
import userList from "./userlist";
import finance from "./finance";
import cloudViewUser from "./cloudviewuser";
import support from "./support";
import subscription from "./subscription";
import traffic from "./traffic";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [
    dashboard,
    master,
    users,
    userList,
    subscription,
    finance,
    applications,
    cloudview,
    transaction,
    cloudViewUser,
    support,
    traffic,
  ],
};

export default menuItems;
